$(function () {
    if ($('#WspPaymentApprovalForm').length > 0) {

        function UpdateFilters(date) {
            if (date === undefined) {
                date = $("#CurrentSubmissionPeriod").val();
            }

            var filterWarning = $("input[type='radio'][name='FilterByWarning']:checked").val();
            var filterStatus = $("input[type='radio'][name='FilterByStatus']:checked").val();
            var searchText = $("input#SearchText").val();

            window.location.href =
                jsPeriodLink + "?submissionPeriod=" + date + "&" +
                "filterWarning=" + filterWarning + "&" +
                "filterStatus=" + filterStatus + "&" +
                "searchString=" + searchText
        }

        $('#SubmissionPeriod').datetimepicker('options', {
            format: "YYYY-MM-DD",
            locale: jsLang + "-ca",
            keepOpen: false,
            defaultDate: false
        });

        $('#SubmissionPeriod').keydown(function (e) {
            e.preventDefault();
        });

        $('#SubmissionPeriod').on('change.datetimepicker', function (e) {
            var date = moment(e.date).format('YYYY-MM-DD');
            var currentDate = $("#CurrentSubmissionPeriod").val();

            if (date != currentDate) {
                UpdateFilters(date);
            }
        });

        $("input[type='radio'][name='FilterByStatus']").on('click', function () {
            UpdateFilters();
        });

        $("input[type='radio'][name='FilterByWarning']").on('click', function () {
            UpdateFilters();
        });

        $("button#SearchButton").on('click', function () {
            UpdateFilters();
        });

        $("input[type='text']#SearchText").on('keyup', function (e) {
            if (e.keyCode == 13) {
                $("button#SearchButton").click();
            }
        });

        function Load() {
            var viewStatus = $("input[type='radio'][name='FilterByStatus']:checked").val();
            var viewWarning = $("input[type='radio'][name='FilterByWarning']:checked").val();

            // Remove/show verify all/submit buttons as appropriate
            if (jsOperCount > 0 && viewWarning == jsViewNoWarning && viewStatus == jsViewReadyStatus) {
                $("div#VerifyAllDiv").removeClass("d-none");
            } else {
                $("div#VerifyAllDiv").addClass("d-none");
            }

            if (jsOperCount > 0 && viewStatus == jsViewReadyStatus) {
                $(".submit-button").removeClass("d-none");
            } else {
                $(".submit-button").addClass("d-none");
            }
        }

        Load();

        // Verified Checkbox logic
        $("input.verified").click(function () {
            // If we change any of the verified boxes, we need to reset the 'select all' check at the bottom.
            $("input#chkCheckAll").prop("checked", false);

            SetVerified($(this));
        });

        function SetVerified(chk) {

            var isVerified = chk.is(":checked");
            var val = chk.val();

            // If verified is checked, we need to uncheck and disable the denied checkbox.
            $("input.denied[value='" + val + "'").each(function () {
                $(this).prop("disabled", isVerified);
                if (isVerified) {
                    if ($(this).is(":checked")) {
                        $("div.denied-detail[data-id='" + val + "'").each(function () {
                            $(this).addClass("d-none");
                        });
                    }

                    $(this).prop("checked", false);
                }
            });
        }

        // Denied Checkbox logic
        $("input.denied").click(function () {

            var val = $(this).val();
            var isCurrentDenied = $(this).is(":checked");
            var detail = $("div.denied-detail[data-id='" + val + "'").first();

            detail.children("span.denied-reason-error").addClass("d-none");

            if (isCurrentDenied) {
                detail.removeClass("d-none");
            } else {
                detail.addClass("d-none");
            }
        });


        $("select.denied-reason").change(function () {
            $(this).siblings(".denied-reason-error").first().addClass("d-none");
            if ($(this).val() == jsWSPPaymentDenialTypeOther) {
                $(this).siblings(".denied-other-detail").first().removeClass("d-none");
            } else {
                $(this).siblings(".denied-other-detail").first().addClass("d-none");
            }
        });

        $("textarea.denied-other-text").keydown(function () {
            $(this).siblings(".denied-other-error").first().addClass("d-none");
        });

        $("input#chkCheckAll").click(function () {
            if ($(this).is(":checked")) {
                $("input.verified:not(:checked)").each(function () {
                    $(this).prop("checked", true);
                    SetVerified($(this));
                });
            } else {
                $("input.verified:checked").each(function () {
                    $(this).prop("checked", false);
                    SetVerified($(this));
                });
            }
        });

        $(".submit-button").on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            if ($("input#chkCheckAll").is(":checked")) {
                $("#confirmModal").modal({
                    'backdrop': 'static'
                });

                return false;
            }

            return Submit();
        });

        $(".submit-button-modal").on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            return Submit();
        });

        function Submit() {
            $(".error-message:not(.d-none)").addClass("d-none");
            $("span.denied-reason-error:not(.d-none)").addClass("d-none");
            $("span.denied-other-error:not(.d-none)").addClass("d-none");

            var hasErrors = false;

            // Gather the verified and denied operators to send back to the server.
            var verifiedList = []

            $("input.verified:checked").each(function () {
                verifiedList.push($(this).val());
            });

            // For denied operators, we need to collect the denied reasons as well.
            var deniedList = [];
            $("input.denied:checked").each(function () {
                val = $(this).val();
                var deniedReason = $("div.denied-detail[data-id='" + val + "'").find("select.denied-reason :selected").first().val();
                var deniedOtherDetail = $("div.denied-detail[data-id='" + val + "'").find("textarea.denied-other-text").first().val();
                var deniedObject = {
                    WSPPaymentId: $(this).val(),
                    DeniedReason: deniedReason,
                    DeniedOtherDetail: deniedOtherDetail
                }
                deniedList.push(deniedObject);


                if (deniedReason == "-1") {
                    hasErrors = true;
                    $("div.denied-detail[data-id='" + val + "'").find(".denied-reason-error").first().removeClass("d-none");
                } else if (deniedReason == jsWSPPaymentDenialTypeOther) {
                    if ($("div.denied-detail[data-id='" + val + "'").find("textarea.denied-other-text").first().val().trim() == "") {
                        hasErrors = true;
                        $("div.denied-detail[data-id='" + val + "'").find(".denied-other-error").first().removeClass("d-none");
                    }
                }
            });

            // Make sure they actually verified or denied anything.
            if (verifiedList.length == 0 && deniedList.length == 0) {
                hasErrors = true;
                $(".error-message").text(jsErrorNoSelection);
                $(".error-message").removeClass("d-none");
            }

            if (!hasErrors) {
                // Fill out our form fields
                $("#VerifiedWSPPaymentIds").val(JSON.stringify(verifiedList));
                $("#DeniedWSPPayments").val(JSON.stringify(deniedList));

                $('#WspPaymentApprovalForm').submit();
            }

            return false;
        }

        $(".reopen-button").on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $("#ReopenWSPPaymentId").val($(this).attr("data-id"));

            $("#reopenModal").modal({
                'backdrop': 'static'
            });

            return false;
        });

        $(".reopen-button-modal").on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            $('#WspPaymentApprovalForm').submit();
            return false;
        });

    } // if ($('#WspPaymentApprovalForm').length > 0)
}); // $(function () {